import { Component, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { AppService } from "../../../services/app.service";
import { ReplaceSavedataTaxinvoiceComponent } from "../replace-savedata-taxinvoice/replace-savedata-taxinvoice.component";
import { Router, ActivatedRoute } from "@angular/router";
import { Storage } from "@ionic/storage";
import { TEXT } from "../../../text_control";
import { BTN } from "../../../text_control/text_button";
import { TEXT_TABLE } from "../../../text_control/text_table";
import { _getStorage } from "../../../utils/local-storage";
import { STORAGE } from "../../../constant/storages";
import { ROUTE } from "../../../constant/routes";
import { ADDRESS } from "../../../text_control/text_address";

@Component({
  selector: "app-replace-checkdata-taxinvoice",
  templateUrl: "./replace-checkdata-taxinvoice.component.html",
  styleUrls: ["./replace-checkdata-taxinvoice.component.scss"],
})
export class ReplaceCheckdataTaxinvoiceComponent implements OnInit {
  enpoint =
    "confirmReplace?code=WBTuOJgaiv5PNa8PxGQ8fpUE0ZIo3RWTgR3TDBIZ5vqqjuf7aKc2Gg==";
  setdata: any;
  addrs: any;
  itemaaddr: any;
  dataitem: any;
  buyer_type: any;
  radio_group: any;
  dataABB: any;
  remark = "";
  isRemark = false;
  showinputremark = false;

  showbranch = false;
  Active = 2;
  notaxid = false;
  nocardID = true;
  nocard = false;

  text: any = {};
  textBTN: any = {};
  textTB: any = {};
  textADDR: any = {};
  isShowBranchNo = true;
  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  constructor(
    public modalController: ModalController,
    public appService: AppService,
    public route: Router,
    public router: ActivatedRoute,
    public storeg: Storage
  ) {
    this.userID = _getStorage(STORAGE.userID)
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.text = TEXT;
    this.textBTN = BTN;
    this.textTB = TEXT_TABLE;
    this.textADDR = ADDRESS;
  }

  ngOnInit() {
    this.setdata = _getStorage(STORAGE.DATA_CHECK_REPLACE);
    this.dataitem = this.setdata[0];
    this.dataABB = this.setdata[0].ABBData[0].salesTicket;
    this.buyer_type = this.dataitem.buyer_type;
    if (this.dataitem.remark !== "") {
      this.isRemark = true;
      this.remark = this.dataitem.remark;
      this.showinputremark = true
    }
    if (this.dataitem.buyer_type === "0" || this.dataitem.buyer_type === "2") {
      this.showbranch = false;
      this.nocard = true;
    } else if (this.dataitem.buyer_type === "1") {
      this.showbranch = true;
      this.notaxid = true;
      this.nocard = true;
    } else if (this.dataitem.buyer_type === "3") {
      this.showbranch = false;
      this.notaxid = false;
      this.nocard = false;
    }

    if (this.dataitem.buyer_main_branch_no) {
      this.radio_group = this.dataitem.buyer_main_branch_no;
    } else {
      this.radio_group = this.dataitem.buyer_branch_no;
    }

    if (this.setdata[0].address_detail[0].type_addr === "1") {
      this.itemaaddr = this.setdata[0].address_detail[0].addr_info;
    } else if (this.setdata[0].address_detail[0].type_addr === "2") {
      this.itemaaddr = this.setdata[0].address_detail[0].addr_infoEN;
    }
    this.ionViewDidEnter();
  }
  ionViewDidEnter() {
    this.router.queryParams.subscribe((params) => {
      if (params.noName === "no_replace") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 2;
      }
    });
  }
  checkremark(e) {
    e.detail.checked == true
      ? (this.showinputremark = true)
      : (this.showinputremark = false);
  }
  async presentModal() {
    this.appService.setActive(4);
    const modal = await this.modalController.create({
      component: ReplaceSavedataTaxinvoiceComponent,
      cssClass: "my-custom-class",
      componentProps: {
        data: this.dataitem,
        buyer_id: this.dataitem.buyer_id,
        email: this.buyer_type === "1"?"":this.setdata[0].address_detail[0].email,
        isShowBranchNo: this.isShowBranchNo,
        remark: this.remark,
      },
    });

    modal.onDidDismiss().then(async () => {});
    return await modal.present();
  }
  backselectreplace() {
    this.appService.setActive(2);
    if (this.Active === 2) {
      this.route.navigate([ROUTE.REPLACE_SELECT]);
    } else {
      this.route.navigate([ROUTE.REPLACE_SELECT], {
        queryParams: { noName: "no_replace", selectedIndex: "4" },
      });
    }
  }

  formatnumber(data) {
    return data.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
}
